import { RadioListField } from 'lib/iterable-hook-form';
import styled from 'styled-components';
import { ErrorBanner } from 'ui/banner';
import { ModalHeader } from 'ui/modal';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { PreviewContent } from 'modules/templateEditor/modals/SmsSmartOptInModal/SmsSmartOptIn.styled';
import { IconButton } from 'ui/button';
import { HelpText } from 'ui/formField';

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  gap: ${spacing.half};
`;

export const FormContainer = styled.div`
  flex-grow: 1;
`;

export const StyledModalHeader = styled(ModalHeader)`
  padding: ${spacing.base} ${spacing.base} ${spacing.threeQuarter} ${spacing.plusHalf};

  &[data-with-icon-button='true'] {
    padding: ${spacing.base} ${spacing.base} ${spacing.threeQuarter} ${spacing.base};
  }
`;

export const StyledErrorBanner = styled(ErrorBanner)`
  margin-bottom: ${spacing.plusHalf};
`;

export const DoubleOptInPreviewContent = styled(PreviewContent)`
  height: ${pxToRem(420)};
`;

export const PreviewSection = styled.div`
  padding-left: ${spacing.plusHalf};
`;

export const StyledRadioListField = styled(RadioListField)`
  margin-top: ${spacing.base};
`;

export const StyledIconButton = styled(IconButton)`
  margin-right: ${spacing.half};
`;

export const DoubleOptInHelpText = styled(HelpText)`
  margin-top: ${spacing.base};
`;
